import { Button, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useSearchParams } from '../../../hooks/useSearchParams';

import styles from './index.module.scss';

const { Search } = Input;

export interface InputSearchProps {
  prefix?: string;
}

export default function InputSearch({ prefix }: InputSearchProps) {
  const { searchParams, replaceSearchParams } = useSearchParams();

  const onSearch: (value: string) => void = (value) => {
    replaceSearchParams({
      [`${prefix || ''}page`]: 1,
      [`${prefix || ''}search`]: value,
    });
  };

  return (
    <Search
      defaultValue={searchParams.get(`${prefix || ''}search`)
        ? searchParams.get(`${prefix || ''}search`)?.toString() : ''}
      placeholder="Search"
      onSearch={onSearch}
      allowClear
      enterButton={(
        <Button size="small" className={styles.searchBtn}>
          <SearchOutlined />
        </Button>
      )}
    />
  );
}
